import { User } from '../../data/models'
import { ApiToken } from '../../core/models'
import { ModelFactory } from '../../../data/factories'

export class AppContext {

  public currentUser: User
  public apiToken: ApiToken

  constructor(
    private _modelFactory: ModelFactory
  ) {
    this.currentUser = this._modelFactory.getNullObject<User>(User.name)
    this.apiToken = null
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/helpers/app-context/app-context.ts